import { Value } from 'app/types-shared';

export enum SavedReportsTypes {
  FOLDER = 3,
  COMPANYREPORTFOLDER = 9,
  DASHBOARDFOLDER = 10
}

export interface SavedReportsValue extends Value {
  children?: Value[];
}

export const ensureEmptyFoldersHaveChildrenProp = (values: SavedReportsValue[]) => {
  const newValues = [];

  values.forEach(value => {
    if (value.children || value.c === SavedReportsTypes.FOLDER || value.c === SavedReportsTypes.COMPANYREPORTFOLDER ||
        value.c === SavedReportsTypes.DASHBOARDFOLDER) {
      const children = value.children || [];

      newValues.push({ ...value, children: ensureEmptyFoldersHaveChildrenProp(children) });
    } else {
      newValues.push(value);
    }
  });

  return newValues;
};
